<template>
  <div
    data-qe-id="loader-indicator"
    ref="loadingIndicator"
    class="loadingIndicator"
    :class="`${show ? 'active' : 'inactive'} ${off ? 'off' : ''}`"
  >
    <div v-if="type === 'circle'" class="circle" :class="size"></div>
    <div v-if="type === 'horizontal'" class="horizontal">
      <div class="horizontal--bounce1"></div>
      <div class="horizontal--bounce2"></div>
      <div class="horizontal--bounce3"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
// TODO vue3: replace component with t-progress !?
import { ref, onMounted, watch } from 'vue'

const props = withDefaults(defineProps<{ type?: 'circle' | 'horizontal'; size?: string; show?: boolean }>(), {
  type: 'circle',
  size: '',
  show: false,
})
let timer: NodeJS.Timer
const off = ref(false)

onMounted(() => {
  // this is required to not show the animation in case off show is initial false
  if (props.show === false) {
    off.value = true
  } else {
    off.value = false
  }
})

watch(
  () => props.show,
  () => {
    if (!props.show) {
      setTimeout(() => {
        // this.$refs.loadingIndicator.style.display = this.show ? "flex" : "none"
        off.value = true
      }, 500)
    } else {
      off.value = false
    }
  }
)
</script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '~@npm/loading-indicator-lib/lib/processingAnimations';

// color, font size
.circle {
  .circleSpinner(@c10-f, 5em);
  .small {
    .circleSpinner(@c10-f, 3em);
  }
}
.horizontal {
  .horizontalSpinner(@c10-f, 0.8em);
}

@animation-color: rgb(255, 255, 255);
@background-color: rgba(245, 250, 252, 0.9);
@size: 2.25em;

.loadingIndicator {
  display: none;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: @background-color;
  z-index: 10;
  justify-content: center;
  align-items: center;
  color: @animation-color;
  font-weight: bold;
}

.loadingIndicator.active {
  display: flex;
}
.loadingIndicator.inactive {
  display: flex;
  -webkit-animation: fade-out 500ms forwards linear;
  animation: fade-out 500ms forwards linear;
}
.loadingIndicator.off {
  display: none;
}
span {
  padding: 0.8em;
}

@keyframes fade-out {
  90% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    // visibility: hidden;
  }
}
</style>
